
import { Component, Prop, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'

@Component
export default class Mp4Player extends Vue {
  @Prop({ type: String, default: '' })
  url!: string

  playVideo () {
    AppModule.playVideo(this.url)
  }
}
